<template>
  <section>
    <div
      class="modal-card"
      style="width: auto"
    >

      <header class="modal-card-head">
        <div class="title is-bold">New Employee/Agent</div>
      </header>

      <section class="modal-card-body">

        <div class="subtitle is-bold">Create a new employee or agent. This person will have a free subscription to Quest while they are employed.</div>

        <b-field
          horizontal
          label="First Name"
        >
          <b-input
            @focus="$event.target.select()"
            name="firstName"
            v-model="c.firstName"
            type="text"
            placeholder="First name"
            expanded
          ></b-input>
        </b-field>

        <b-field
          horizontal
          label="Last Name"
        >
          <b-input
            @focus="$event.target.select()"
            name="lastName"
            v-model="c.lastName"
            type="text"
            placeholder="Last name"
            expanded
          ></b-input>
        </b-field>

        <b-field
          horizontal
          label="Email"
        >
          <b-input
            @focus="$event.target.select()"
            name="email"
            v-model="c.email"
            type="text"
            placeholder="Email address"
            expanded
          ></b-input>
        </b-field>

        <b-field
          horizontal
          label="Password"
        >
          <b-input
            @focus="$event.target.select()"
            name="password"
            v-model="c.password"
            type="text"
            placeholder="Password"
            expanded
          ></b-input>
        </b-field>

        <b-field
          horizontal
          label="Is Agent?"
        >
          <b-switch
            v-model="c.isAgent"
            true-value="Yes"
            false-value="No"
          >
            {{ c.isAgent }}
          </b-switch>
        </b-field>

      </section>

      <footer class="modal-card-foot">
        <button
          class="button"
          @click="() => { cancel(); $parent.close() }"
        >Cancel</button>
        <button
          :disabled="c.firstName.length == 0 || c.lastName.length == 0 || c.email.length == 0 || c.password.length < 4"
          class="button is-primary"
          @click="saveNew()"
        >Create new employee/agent</button>
      </footer>

    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      c: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        isAgent: "No"
      }
    };
  },

  mounted() {
    this.c.firstName = "";
    this.c.lastName = "";
    this.c.email = "";
    this.c.password = "";
    this.c.isAgent = "No";
  },

  methods: {
    cancel() {
      console.log("cancel()");
    },

    saveNew() {
      var firstName = this.c.firstName;
      var lastName = this.c.lastName;
      var email = this.c.email;
      var password = this.c.password;
      var isAgent = this.c.isAgent == "Yes";
      this.$store
        .dispatch("newSubscriptionEmployee", {
          firstName,
          lastName,
          email,
          password,
          isAgent
        })
        .then(response => {
          console.log(response);
          this.showSuccess(`${firstName} ${lastName} successfully created`);
        });
    }
  }
};
</script>

<style>
</style>
